import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import * as ConfigActions from '../actions/config.actions';
import { ThemeService } from '../../../core/service/theme.service';
import { WorkflowService } from 'src/app/services/workflow.service';

@Injectable()
export class ConfigEffects {
  loadConfigs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ConfigActions.loadConfig),
      map(() =>
        ConfigActions.loadConfigSuccess({
          theme: this.themeService.getConfig(),
        })
      )
    );
  });

  loadWFStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ConfigActions.loadWFStatus),
      switchMap(() => {
        return this.workFlowService.getWorkFlowStates().pipe(
          map((resp) => {
            return ConfigActions.loadWFStatusSuccess({ states: resp });
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private themeService: ThemeService,
    private workFlowService: WorkflowService
  ) {}
}
